import { useAuth } from "../context/AuthContext";
import { PERMISSIONS } from "../utils/permissions";
import { normalizeRole } from "../utils/roles";

export default function usePermission() {
 const { currentUser } = useAuth();

  // لو مفيش مستخدم
  if (!currentUser) {
    return () => false;
  }

  const rolePermissions = PERMISSIONS[normalizeRole(currentUser.role)] || {};

  // function ترجع true / false
  const can = (permission) => {
    return !!rolePermissions[permission];
  };

  return can;
}